import React, { useCallback } from 'react';
import { useField } from 'formik';
import PropTypes from 'prop-types';

import { PRESCRIPTION_COMMENT } from 'store/diagnoses';
import TextArea from 'components/TextAreaNew';
import QuestionContainer from 'components/QuestionContainer';

const CommentForm = ({ readMode }) => {
  const [{ value: comment }, , { setValue: setComment }] = useField(PRESCRIPTION_COMMENT);

  const handleChangeComment = useCallback(
    (text) => {
      if (!readMode) setComment(text);
    },
    [readMode, setComment]
  );

  return (
    <QuestionContainer label="Bemerkungen zum Rezept">
      <TextArea placeholder="Kommentar" value={comment} onChangeText={handleChangeComment} rows={8} readMode={readMode} />
    </QuestionContainer>
  );
};

CommentForm.propTypes = { readMode: PropTypes.bool.isRequired };

export default CommentForm;
